import React, { Component } from 'react';
import { TextField, Grid, Typography, MenuItem, Checkbox, FormGroup, FormControlLabel, FormLabel, FormHelperText, RadioGroup, Radio, StylesProvider, Divider, withStyles } from "@material-ui/core";
import { green, red } from '@material-ui/core/colors';

import './Step.scss';

const GreenRadio = withStyles({
  root: {
    color: green[400],
    '&$checked': {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

const RedRadio = withStyles({
  root: {
    color: red[400],
    '&$checked': {
      color: red[600],
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

class YearControlForm extends Component {
  
render() {

    return (
	  <>
        <Grid item xs={12}>
          <Typography className="form-titel" variant="h6">Kontrolle - Jahr</Typography>
        </Grid>
		<StylesProvider injectFirst>
		<Grid container item xs={12}>
		  <Grid item xs={12} sm={6}>
		    <FormGroup>
		      <FormLabel component="legend" className="check-titel" >Dokumentation*</FormLabel>
		  	  <RadioGroup
                row
                aria-label="position"
		  	    name="ist_jahr_dokumentation"
		  	    value={this.props.values.ist_jahr_dokumentation}
		  	    onChange={this.props.handleRadioChange}
		  	  >
		        <FormControlLabel
		  	      value={true}
                  control={<GreenRadio required={true} /> }
		  	      label="i.O."
		  	      labelPlacement="start"
                />
		  	    <FormControlLabel
		  	      value={false}
                  control={<RedRadio required={true} /> }
		  	      label="nicht i.O."
		  	      labelPlacement="end"
		  	      className="input-no"
                />
		  	  </RadioGroup>
			  <FormHelperText>Anlagenordner und Notfallzettel in Absprache mit LBU aktualisieren und ausgefüllte Formulare scannen zur elektronischen Ablage</FormHelperText>
			</FormGroup>
		  </Grid>
		  <Grid item xs={12} sm={6}>
            <TextField
			  id={'ist_jahr_dokumentation_bemerkung' + this.props.values.id}
              label="Bemerkung"
              name="ist_jahr_dokumentation_bemerkung"
              variant="outlined"
              fullWidth
              multiline
              rows={3}
			  value={this.props.values.ist_jahr_dokumentation_bemerkung}
              onChange={this.props.handleChange}
			  className="step-input"
            />
          </Grid>
	    </Grid>
		<Divider />
		<Grid container item xs={12}>
		  <Grid item xs={12} sm={6}>
		    <FormGroup>
		      <FormLabel component="legend" className="check-titel">Notbeleuchtung*</FormLabel>
		  	  <RadioGroup
                row
                aria-label="position"
		  	    name="ist_jahr_notbeleuchtung"
		  	    value={this.props.values.ist_jahr_notbeleuchtung}
		  	    onChange={this.props.handleRadioChange}
		  	  >
		        <FormControlLabel
		  	      value={true}
                  control={<GreenRadio required={true} /> }
		  	      label="i.O."
		  	      labelPlacement="start"
                />
		  	    <FormControlLabel
		  	      value={false}
                  control={<RedRadio required={true} /> }
		  	      label="nicht i.O."
		  	      labelPlacement="end"
		  	      className="input-no"
                />
		  	  </RadioGroup>
			  <FormHelperText>Funktionskontrolle der Notleuchten, Schilder, Markierungen, Fluchtwegmarkierung</FormHelperText>
			</FormGroup>
		  </Grid>
		  <Grid item xs={12} sm={6}>
            <TextField
			  id={'ist_jahr_notbeleuchtung_bemerkung' + this.props.values.id}
              label="Bemerkung"
              name="ist_jahr_notbeleuchtung_bemerkung"
              variant="outlined"
              fullWidth
              multiline
              rows={4}
			  value={this.props.values.ist_jahr_notbeleuchtung_bemerkung}
              onChange={this.props.handleChange}
			  className="step-input"
            />
          </Grid>
	    </Grid>
		<Divider />
		<Grid container item xs={12}>
		  <Grid item xs={12} sm={6}>
		    <FormGroup>
		      <FormLabel component="legend" className="check-titel">Feuerlöscher*</FormLabel>
		  	  <RadioGroup
                row
                aria-label="position"
		  	    name="ist_jahr_feuerloescher"
		  	    value={this.props.values.ist_jahr_feuerloescher}
		  	    onChange={this.props.handleRadioChange}
		  	  >
		        <FormControlLabel
		  	      value={true}
                  control={<GreenRadio required={true} /> }
		  	      label="i.O."
		  	      labelPlacement="start"
                />
		  	    <FormControlLabel
		  	      value={false}
                  control={<RedRadio required={true} /> }
		  	      label="nicht i.O."
		  	      labelPlacement="end"
		  	      className="input-no"
                />
		  	  </RadioGroup>
			  <FormHelperText>Betriebsbereitschaft, Standort, Kontrolle Durchführung externer Service</FormHelperText>
			</FormGroup>
		  </Grid>
		  <Grid item xs={12} sm={6}>
            <TextField
			  id={'ist_jahr_feuerloescher_bemerkung' + this.props.values.id}
              label="Bemerkung"
              name="ist_jahr_feuerloescher_bemerkung"
              variant="outlined"
              fullWidth
              multiline
              rows={3}
			  value={this.props.values.ist_jahr_feuerloescher_bemerkung}
              onChange={this.props.handleChange}
			  className="step-input"
            />
          </Grid>
	    </Grid>
		<Divider />
		<Grid container item xs={12}>
		  <Grid item xs={12} sm={6}>
		    <FormGroup>
		      <FormLabel component="legend" className="check-titel">Reinigung*</FormLabel>
		  	  <RadioGroup
                row
                aria-label="position"
		  	    name="ist_jahr_reinigung"
		  	    value={this.props.values.ist_jahr_reinigung}
		  	    onChange={this.props.handleRadioChange}
		  	  >
		        <FormControlLabel
		  	      value={true}
                  control={<GreenRadio required={true} /> }
		  	      label="i.O."
		  	      labelPlacement="start"
                />
		  	    <FormControlLabel
		  	      value={false}
                  control={<RedRadio required={true} /> }
		  	      label="nicht i.O."
		  	      labelPlacement="end"
		  	      className="input-no"
                />
		  	  </RadioGroup>
			  <FormHelperText>innerhalb und ausserhalb des Gebäudes </FormHelperText>
			</FormGroup>
		  </Grid>
		  <Grid item xs={12} sm={6}>
            <TextField
			  id={'ist_jahr_reinigung_bemerkung' + this.props.values.id}
              label="Bemerkung"
              name="ist_jahr_reinigung_bemerkung"
              variant="outlined"
              fullWidth
              multiline
              rows={3}
			  value={this.props.values.ist_jahr_reinigung_bemerkung}
              onChange={this.props.handleChange}
			  className="step-input"
            />
          </Grid>
	    </Grid>
      </StylesProvider>
    </>
	)
}
}

export default YearControlForm;
